<template>
    <div>
        <cityinfo-header></cityinfo-header>
        <section id="home" class="k12-banner py-md-5 pt-md-0 pt-sm-5 pt-4">
            
        </section>
        <section class="w3l-new-block-6 py-5">
            <div class="container py-md-4 py-3">
                <div class="title-heading-w3 text-center mx-auto">
                    <h3 class="title-main">最新消息</h3>
                    <p class="mt-4 sub-title">
                        公告單位：
                        <select class="form-control" style="width:auto; display:inline" v-model="dept">
                            <option value="">全部</option>
                            <option v-for="(item, i) in $root.depts" :key="i" :value="item">{{item}}</option>
                        </select>
                    </p>
                </div>
                <div class="d-grid mt-5 pt-lg-3" style="margin-bottom : 2rem;" id="k12News">
                    <div class="grids5-info" style="background-color:#FFF;" v-for="(item, i) in showProclamationList" :key="i">
                        <div class="department" style="background-color:#2864FF;">{{item.publisherDept}}</div>
                        <h5 style="height:100px;">
                            <a href="javascript:;" :alt="item.title" :index="i" @click="gotoView(`subject`,{id:item.id})">{{item.title.length > 40 ? item.title.substring(0,40) : item.title}}</a>
                        </h5>
                        <ul class="admin-list">
                            <li></li>
                            <li><span><i class="las la-calendar"></i></span>{{item.createDate ? customFormatter(item.createDate, "YYYY/MM/DD") : ""}}</li>
                        </ul><hr>
                        <p class="department-content" style="height:75px;" v-html="htmlDecode(item.contentValue)"></p>
                    </div>
                </div>
                <div class="row content-sec mt-md-5 mt-4 justify-content-md-center">
                    <div class="col-lg-offset-5 col-lg-2 col-md-offset-5 col-md-2 ">
                        <button type="button" class="btn  btn-lg w-100" style="color:rgb(0, 121, 198);" @click="loadMove" v-if="proclamationList.length != showProclamationList.length">載入更多</button>
                    </div>
                </div>
            </div>
        </section>
        <cityinfo-footer></cityinfo-footer>
    </div>
</template>
<script>
import header from "./header";
import footer from './footer';
export default {
    components:{
        "cityinfo-header":header,
        "cityinfo-footer":footer
    },
    data(){
        return {
            showProclamationList:[],
            proclamationList:[],
            dept:"",
            beginIdx:1,
            endIdx:12,
            gap:12
        }
    },
    mounted(){
        
        this.$http.get("/api/Index/").then(a => {
            if(a.body){
                this.proclamationList = a.body;
                this.loadData();
            }
        });
    },
    methods:{
        htmlDecode(decodeValue){
			const div = document.createElement('div');
            div.innerHTML = decodeValue;
            let str = div.textContent.replace(/<[^>]+>/g,"");
			return str.substring(0, 25);
		},
        loadMove(){
            this.beginIdx += this.gap;
            this.endIdx += this.gap;
            this.loadData();
        },
        loadData(){
            let searchList = this.proclamationList.filter(a => {
                return a.idx >= this.beginIdx && a.idx <= this.endIdx
            });
            for(let i in searchList){
                this.showProclamationList.push(searchList[i]);
            }
        }
    },
    watch:{
        dept(val){
            if(val){
                this.showProclamationList = this.proclamationList.filter(item => {
                    return item.publisherDept == val;
                });
            }else{
                this.showProclamationList = this.proclamationList;
            }
            return val
        }
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>

/*-- banner --*/
.k12-banner {
  background: url(../assets/images/k12-banner.jpg) no-repeat center;
  -ms-background-size: cover;
  background-size: cover;
  position: relative;
  min-height: 600px;
}

.title-decoration{
    position: absolute;
    width: 2%;
    height: 90%;
    background-color: #365B6D;
}
@media (min-width: 1366px){
    .title-decoration{
        margin-top: -1%;
        margin-left: -5%;
    }
}
@media (max-width: 1366px){
    .title-decoration{
        margin-top: -1%;
        margin-left: -5%;
    }
}
@media (max-width:900px){
    .title-decoration{
        margin-top: -1%;
        margin-left:2%;
    }
}
@media (max-width:736px){
    .title-decoration{
        margin-top: -1%;
        margin-left:2%;
    }
    .k12-banner {
        background: url(../assets/images/k12-banner-mobile.jpg) no-repeat center;
        -ms-background-size: cover;
        background-size: 100%;
        position: relative;
        min-height: 450px;
    }
}
@media only screen and (max-device-height : 736px) {
    .k12-banner {
        min-height: 250px;
    }
}


</style>